import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AddPlayerDomain } from '../addPlayer.domain';
import { PlayerCard } from '../../../components/playerCard/playerCard';
import { AlertDialog } from '../../../components/alertDialog/alertDialog';
import { AddPlayer } from '../addPlayerModal/addPlayer';
import { ConneqtOnAddPlayerDomain } from '../addConneqtModal/conneqtOnAddPlayer.domain';
import { AddConneqtModal } from '../addConneqtModal/addConneqtModal';
import { AddPlayerButton } from '../addPlayerModal/addPlayerButton';

interface PlayerListCardProps {
  playerDomain: AddPlayerDomain;
  conneqtOnAddPlayerDomain: ConneqtOnAddPlayerDomain;
}

export const PlayerListByCard = ({
  playerDomain,
  conneqtOnAddPlayerDomain,
}: PlayerListCardProps) => {
  const players = playerDomain.usePlayersSelector();
  const [showAddPlayerModal, setShowAddPlayerModal] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        <AddPlayerButton onPress={() => setShowAddPlayerModal(true)} />
      </Grid>
      <Grid container spacing={2} sx={{ mb: 2, ml: 0.5 }}>
        {players.length > 0 ? (
          players
            .sort((a, b) => Number(a.clearedToPlay) - Number(b.clearedToPlay))
            .map((playerItem) => {
              return (
                <Grid item xs={12} sm={12} md={4} lg={4} key={playerItem.id}>
                  <PlayerCard key={playerItem.id} player={playerItem} />
                </Grid>
              );
            })
        ) : (
          <Grid item>{t('NO_PLAYERS_IN_YOUR_FAMILY')}</Grid>
        )}
      </Grid>
      <AlertDialog
        title={t('ADD_PLAYER').toString()}
        setOpen={setShowAddPlayerModal}
        open={showAddPlayerModal}
        content={
          <AddPlayer
            dispatchCreatePlayer={conneqtOnAddPlayerDomain.dispatchCreatePlayer}
            closeModal={setShowAddPlayerModal}
          />
        }
      />
      <AddConneqtModal />
    </>
  );
};
